var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParagraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.278,8.838H4.722a.75.75,0,0,0,0,1.5H19.278a.75.75,0,0,0,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.722,5.513H19.278a.75.75,0,0,0,0-1.5H4.722a.75.75,0,0,0,0,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.278,13.662H4.722a.75.75,0,0,0,0,1.5H19.278a.75.75,0,0,0,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.222,18.487h-6.5a.75.75,0,0,0,0,1.5h6.5a.75.75,0,0,0,0-1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.28f66c501e62e227569cabe5b65915a6.svg";
export { ForwardRef as ReactComponent };